import {useCallback, useEffect, useMemo} from "react";
import {useNavigate} from "react-router-dom";

import {MakerFeatures} from "~/features";
import {selectUser, useAppSelector} from "~/modules/redux";
import {INVITE_SETUP_PATH} from "~/modules/routing";

export const useInvitation = () => {
  const navigate = useNavigate();
  const {maker, impersonation} = useAppSelector(selectUser);

  const chargeMethodToAccept = useMemo(() => {
    if (!maker?.features.includes(MakerFeatures.ChargeMethod)) return;
    if (!maker.onboarding?.chargeMethods) return;
    return maker.onboarding.chargeMethods;
  }, [maker]);

  const goToInvitePage = useCallback(() => {
    navigate(INVITE_SETUP_PATH);
  }, [navigate]);

  useEffect(() => {
    if (impersonation) return;
    if (!maker?.onboarding?.termsToAccept.length) return;
    goToInvitePage();
  }, [maker, goToInvitePage, impersonation]);

  useEffect(() => {
    if (impersonation) return;
    if (chargeMethodToAccept === undefined) return;
    if (chargeMethodToAccept.length > 0) return;
    goToInvitePage();
  }, [chargeMethodToAccept, goToInvitePage, impersonation]);
};
